import { useRef, useState, useEffect } from "react";
const useAnimationClass = ({
  valueToTrack,
  animateIn,
  animateOut
}) => {
  const rendered = useRef(false);
  const [animationClass, setAnimationClass] = useState("");
  const [show, setShow] = useState(valueToTrack);
  useEffect(() => {
    valueToTrack && setShow(true);
    if (!rendered.current) {
      rendered.current = true;
      return;
    }
    if (valueToTrack) {
      setAnimationClass(animateIn);
    } else {
      setAnimationClass(animateOut);
    }
  }, [animateIn, animateOut, valueToTrack]);
  return {
    showElement: show,
    animationClass,
    onAnimationEnd: () => setShow(valueToTrack)
  };
};
export {
  useAnimationClass
};
